//
export default [
    {
        field: 'wh_product_id',
        type: 'autocompleteObject',
        vuetifyProps: {
            label: 'Producto',
        },
        options: {
            data: [],
            text: 'name',
            value: 'id',
        },
        rules: [ 'required' ],
    },
    {
        field: 'quantity',
        type: 'text',
        vuetifyProps: {
            label: 'Cantidad',
        },
        rules: [ 'required' ],
    },
]